__webpack_require__.p = "https://docs.material-tailwind.com/_next/";